// tslint:disable: completed-docs
import { connect, injectReducer, injectSaga, toggleOverlay, trackingBasedOnState } from '@vfde-fe/sails_core';
import { createStructuredSelector } from 'reselect';
import { RootState } from './types';

import NAMESPACE, {
    OVERLAY_GIGAKOMBI_CONTAINER_ID,
    SET_TRACKING_STATE,
    GIGAKOMBI_OVERLAY_NAME,
    TRADE_IN_OVERLAY_NAME,
} from './constant';
import reducer from './reducer';
import overlaySaga from './saga';

import './style.scss';

import {
    selectRootOverlayNameState,
    selectRootOverlayState,
} from './selector';

import {
    preloadGigaKombiOverlay,
    trackOverlay,
} from './action';

import {
    StateProps,
} from './interface';

import {
    mountOverlay, showOverlay,
} from './components/Overlay';
import { gigaKombiXSellHelper } from '../../components/gigaKombiXSellHelper';

import { resetOverlayGigaKombiOverlay, triggerGigaKombiOverlay } from './helper/triggerGigaKombiOverlay';

/**
 * Overlay function
 */
function overlay (state, actions) {
    injectReducer(NAMESPACE, reducer);
    injectSaga(NAMESPACE, overlaySaga);
    const scriptTarget = document.getElementsByTagName('head')[0];
    const gigaKombiXSellHelpers = gigaKombiXSellHelper(OVERLAY_GIGAKOMBI_CONTAINER_ID);

    actions.preloadGigaKombiOverlay(gigaKombiXSellHelpers.contentTarget, scriptTarget);
    mountOverlay(actions.toggleOverlay);

    return {
        getDerivedStateFromProps (newState, oldState) {
            if (newState.overlayName !== TRADE_IN_OVERLAY_NAME) {
                trackingBasedOnState(SET_TRACKING_STATE, newState, oldState, actions.trackOverlay);
            }

            if (newState.overlayName === GIGAKOMBI_OVERLAY_NAME) {
                newState.overlayState ? triggerGigaKombiOverlay(gigaKombiXSellHelpers) : resetOverlayGigaKombiOverlay(gigaKombiXSellHelpers);
            }
        },
    };
}

const mapStateToProps = createStructuredSelector<RootState, StateProps>({
    overlayState: selectRootOverlayState(),
    overlayName: selectRootOverlayNameState(),
});

const mapDispatch = {
    toggleOverlay,
    trackOverlay,
    preloadGigaKombiOverlay,
};

const Overlay = connect(mapStateToProps, mapDispatch)(overlay);
export default Overlay;
